import { IonButtons, IonGrid,IonContent, IonHeader,IonIcon, IonMenuButton, IonPage, IonRow, IonText, IonTitle, IonToolbar } from '@ionic/react';
import { calendarOutline   } from 'ionicons/icons';

const Autores = (props) => {

    return (
        <IonPage>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonMenuButton />
                    </IonButtons>
                    <IonTitle   className='headertitle' style={{ fontSize: "24"}}>{props.lang==='ES'?'Autores':'Authors'}</IonTitle>
                </IonToolbar>

            <IonContent className=''>
                <IonGrid className="paddingh20 textblack ion-padding-start ion-padding-end extra-padding ion-padding-bottom ion-margin-bottom">

                <IonRow className="mt2 mx2 mb2 f2" >
                {props.lang==='ES'?'Árbol de decisión para el tratamiento farmacológico de la insuficiencia cardiaca crónica':'Decision tree for pharmacological treatment of chronic heart failure'}
                
        </IonRow>


                <IonRow className="mb1 mx2" >
                    <IonText>Adán Gil F (+)</IonText>
                </IonRow>
                <IonRow className="mb1 mx2">
                    <IonText> Aranbarri Osoro I (+)</IonText>
                    </IonRow>
                <IonRow className="mb1 mx2">

                    <IonText> Barrot de la Puente J (+)</IonText>
                </IonRow>
                <IonRow className="mb1 mx2">
                    <IonText> Cebrián-Cuenca A (+)</IonText>
                    </IonRow>
                <IonRow className="mb1 mx2">

                    <IonText> Franch-Nadal J (+)</IonText>
                </IonRow>
                <IonRow className="mb1 mx2">
                    <IonText> Gracia García O (++)</IonText>

                </IonRow>
                <IonRow className="mb1 mx2">
                    <IonText> Pardo Franco J (+)</IonText>
                    </IonRow>
                <IonRow className="mb1 mx2">

                    <IonText> Ruiz Quintero M (+)</IonText>
                </IonRow>
                <IonRow className="mb1 mx2">
                    <IonText> Valle Muñoz A (+++)</IonText>
                </IonRow>
                <IonRow className="mb1 mx2 f1">
                    <IonText>(+) {props.lang==='ES'?'Red de Grupos de estudios de la Diabetes en atención Primaria de la Salud. (redGDPS)':'Network of Diabetes Study Groups in Primary Health Care (redGDPS).'}</IonText>
                </IonRow>
                <IonRow className="mb1 mx2 f1">
                    <IonText>(++) {props.lang==='ES'?'Servicio de Nefrología. Hospital Universitario Miguel Servet. Zaragoza.':'Nephrology Service, Miguel Servet University Hospital, Saragossa,'}</IonText>
                </IonRow>
                <IonRow className="mb1 mx2 f1">
                    <IonText>(+++) {props.lang==='ES'?'Servicio de Cardiología. Hospital Marina Salud. Dénia (Alicante).':'Cardiology Service, Marina Salud Hospital, Dénia (Alicante).'}</IonText>

                </IonRow>

              <IonRow className="mt2 mx2 mb2 ">
              <IonIcon icon={calendarOutline} ></IonIcon><IonText> {props.lang==='ES'?'Publicado: Enero 2022 · Actualizado: Octubre 2023':'Published: January 2022 · Updated: October 2023'} </IonText>
        </IonRow>
        <IonRow className="mt2 mb2 mx2 ">
        <IonText>DOI: https://doi.org/10.52102/arbolttoicfe</IonText>
        </IonRow>
        </IonGrid>
            </IonContent>
        </IonPage>
    );
};

export default Autores;
